import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Mentions Légales - CasaReNovaPlus",
  "url": `${import.meta.env.VITE_SITE_URL}/mentions-legales`,
  "description": "Mentions légales de HB SERVICES, entreprise CVSE à Genève, Suisse romande.",
  "publisher": { "@type": "Organization", "name": "CasaReNovaPlus" }
};

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Mentions Légales - CasaReNovaPlus Neuenegg"
        description="Mentions légales de HB SERVICES, entreprise générale CVSE à Genève et en Suisse romande. Informations légales, protection des données, propriété intellectuelle."
        keywords="mentions légales HB SERVICES, informations légales Genève, protection données Suisse"
        canonical={`${import.meta.env.VITE_SITE_URL}/mentions-legales`}
        schema={schema}
      />
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Mentions Légales</h1>
          
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Éditeur du site</h2>
              <p className="mb-2"><strong>Raison sociale :</strong> CasaReNovaPlus</p>
              <p className="mb-2"><strong>Adresse :</strong> Austrasse 95, 3176 Neuenegg, Suisse</p>
              <p className="mb-2"><strong>Téléphone :</strong> Filipe Oliveira: +41 76 480 31 88 | Francisco Andrade: +41 76 565 42 03</p>
              <p className="mb-2"><strong>Email :</strong> info@casarenovaplus.ch</p>
              <p className="mb-2"><strong>Site web :</strong> <a href="https://casarenovaplus.ch" className="text-teal-600 hover:text-teal-700 transition-colors">https://casarenovaplus.ch</a></p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Buts de la société</h2>
              <p className="mb-4 leading-relaxed">La société a pour buts :</p>
              <ul className="list-disc list-inside space-y-3 ml-4">
                <li className="leading-relaxed">
                  <strong>Activités techniques</strong> incluant l'installation, l'exécution, la maintenance, le dépannage et le suivi d'équipements et d'installations techniques.
                </li>
                <li className="leading-relaxed">
                  <strong>Prestations de nettoyage et d'entretien</strong> pour particuliers, entreprises et locaux professionnels, incluant le nettoyage courant et spécialisé.
                </li>
                <li className="leading-relaxed">
                  <strong>Services de conciergerie</strong>, gestion et entretien d'immeubles.
                </li>
                <li className="leading-relaxed">
                  <strong>Achat, vente, importation, exportation et distribution</strong> de matériel, produits et équipements liés aux domaines d'activité.
                </li>
                <li className="leading-relaxed">
                  <strong>Services de formation et de conseil</strong> dans les secteurs du nettoyage, de la maintenance et des services techniques.
                </li>
                <li className="leading-relaxed">
                  <strong>Toutes opérations commerciales, financières ou techniques</strong> se rattachant directement ou indirectement au but principal.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Directeur de publication</h2>
              <p>Le directeur de la publication du site est le représentant légal de HB SERVICES.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Hébergement</h2>
              <p className="mb-2">Ce site est hébergé par :</p>
              <p className="mb-2"><strong>Readdy.ai</strong></p>
              <p className="mb-2">Service d'hébergement web professionnel</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Propriété intellectuelle</h2>
              <p className="mb-4">L'ensemble de ce site relève de la législation suisse et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.</p>
              <p>La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Protection des données personnelles</h2>
              <p className="mb-4">Conformément à la Loi fédérale sur la protection des données (LPD), vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données vous concernant.</p>
              <p className="mb-4">Pour exercer ce droit, vous pouvez nous contacter :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Par email : info@casarenovaplus.ch</li>
                <li>Par téléphone : +41 76 480 31 88 (Filipe) ou +41 76 565 42 03 (Francisco)</li>
                <li>Par courrier : Austrasse 95, 3176 Neuenegg, Suisse</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies</h2>
              <p className="mb-4">Ce site peut utiliser des cookies pour améliorer l'expérience utilisateur. Les cookies sont de petits fichiers texte stockés sur votre ordinateur par votre navigateur web.</p>
              <p>Vous pouvez configurer votre navigateur pour refuser les cookies ou pour vous avertir lorsqu'un cookie est envoyé. Cependant, certaines parties du site peuvent ne pas fonctionner correctement sans cookies.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Liens hypertextes</h2>
              <p className="mb-4">Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de CasaReNovaPlus.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Limitation de responsabilité</h2>
              <p className="mb-4">CasaReNovaPlus s'efforce d'assurer au mieux de ses possibilités, l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, CasaReNovaPlus ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.</p>
              <p>En conséquence, CasaReNovaPlus décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Droit applicable</h2>
              <p>Les présentes mentions légales sont régies par le droit suisse. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux suisses conformément aux règles de compétence en vigueur.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Crédits</h2>
              <p className="mb-2"><strong>Conception et développement :</strong> <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 transition-colors">Readdy.ai</a></p>
              <p><strong>Dernière mise à jour :</strong> Avril 2026</p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}